import {Employee} from 'client';
import {atom} from 'jotai';

export const gratitudeRecipient = atom<Employee | undefined>(undefined);
